import axios from 'axios'
import * as types from './types'
import { push } from 'connected-react-router'
import { users, password } from 'config/users.config'
import { AUTH, ACCOUNT, NOTIFICATION_SETTINGS, PHOTO_FILTER, SUBSCRIPTIONS } from 'common/endpoints'
import { openModal } from '../modals/actions'
import { fetchMyProfile } from '../myProfile/actions'
import { fetchLabels } from '../translations/actions'
import { PROFILE_UPDATE_MODAL } from 'components/Modal/modalTypes'

export const login = (login, password) => axios.post(AUTH.LOGIN, { login, password })
export const logout = () => axios.post(AUTH.LOGOUT).finally(() => (window.location.href = '/'))

export const localLogin = () => {
  let { email, user } = sessionStorage
  user = email ? { email, password } : users[user || 0] || {}

  return login(user.email, user.password).catch(() => {})
}

export const localLogout = () => axios.post(AUTH.LOGOUT).catch(() => {})

export const fetchAccount = () => ({
  type: types.FETCH_ACCOUNT,
  meta: { url: ACCOUNT.GET },
})

export const updateAccount = (data, iso) => ({
  type: types.UPDATE_ACCOUNT,
  meta: {
    method: 'PUT',
    url: ACCOUNT.UPDATE,
    data,
    onSuccess: [openModal(PROFILE_UPDATE_MODAL), fetchLabels(iso)],
  },
})

export const fetchConfirmation = () => ({
  type: types.FETCH_CONFIRMATION,
  meta: { url: ACCOUNT.REGISTRATION_CONFIRMATION },
})

export const confirmRegistration = data => ({
  type: types.CONFIRM_REGISTRATION,
  meta: { method: 'PUT', url: ACCOUNT.REGISTRATION_CONFIRMATION, data },
})

export const deleteAccount = ({ password, reason }) => ({
  type: types.DELETE_ACCOUNT,
  meta: { method: 'PUT', url: ACCOUNT.DELETE, data: { password, reason } },
})

export const fetchNotificationSettings = () => ({
  type: types.FETCH_NOTIFICATION_SETTINGS,
  meta: { url: NOTIFICATION_SETTINGS },
})

export const updateNotificationSettings = data => ({
  type: types.UPDATE_NOTIFICATION_SETTINGS,
  meta: {
    method: 'PUT',
    url: NOTIFICATION_SETTINGS,
    data,
    onSuccess: [openModal(PROFILE_UPDATE_MODAL), fetchNotificationSettings()],
  },
})

const trimMailType = messageId =>
  messageId
    .split('.')
    .slice(0, 3)
    .join('.')
export const unsubscribeEmails = ({ hash, messageId }) => ({
  type: types.UNSUBSCRIBE_EMAILS,
  meta: {
    method: 'PUT',
    url: ACCOUNT.UNSUBSCRIBE_EMAILS,
    data: { hash, messageId: trimMailType(messageId), status: '', subscriptionName: 'any emails' },
    onSuccess: [openModal(PROFILE_UPDATE_MODAL), push('/myprofile/settings')],
  },
})

export const updatePhotoFilter = (data, { silent } = {}) => ({
  type: types.UPDATE_PHOTO_FILTER,
  meta: {
    method: 'GET',
    url: PHOTO_FILTER + data,
    onSuccess: (silent ? [] : [openModal(PROFILE_UPDATE_MODAL)]).concat(fetchMyProfile({ silent })),
  },
})

export const fetchSubscriptions = () => ({
  type: types.FETCH_SUBSCRIPTIONS,
  meta: { url: SUBSCRIPTIONS.GET },
})

export const cancelSubscription = ({ agreementId, password, reason, reasonId }) => ({
  type: types.CANCEL_SUBSCRIPTION,
  meta: {
    url: SUBSCRIPTIONS.delete(agreementId),
    method: 'PUT',
    data: {
      agreementId,
      password,
      reason,
      reasonId,
    },
  },
})

export const resendConfirmationEmail = ({ email, field }) => ({
  type: types.RESEND_CONFIRMATION_EMAIL,
  meta: {
    url: ACCOUNT.RESEND_CONFIRMATION_EMAIL,
    method: 'PUT',
    data: {
      email,
    },
  },
  field,
})

export const submitHelpForm = data => ({
  type: types.SUBMIT_HELP_FORM,
  meta: { method: 'PUT', url: ACCOUNT.HELP, data },
})

export const startIntro = () => ({ type: types.INTRO_START })

export const finishIntro = () => {
  delete localStorage.recentlyJoined
  return { type: types.INTRO_FINISH }
}
